/**
 * Categorias de cupom de loja persistidas em `newCategory` (Firestore).
 * O valor de Envio para BFLUs precisa coincidir com o KPI de margem na admin-api.
 */
export const SHOP_COUPON_CATEGORY_BFLU_SHIPMENT = 'ENVIO PARA BFLUS';

export const SHOP_COUPON_CATEGORIES: ReadonlyArray<{
  value: string;
  label: string;
  displayName: string;
}> = [
  { value: 'API-001', label: 'API-001', displayName: 'API 001' },
  {
    value: 'COMPRE E GANHE',
    label: 'Compre e Ganhe',
    displayName: 'Compre e Ganhe'
  },
  { value: 'DESCONTO', label: 'Desconto', displayName: 'Desconto' },
  { value: 'REEMBOLSO', label: 'Reembolso', displayName: 'Reembolso' },
  { value: 'DESCULPAS', label: 'Desculpas', displayName: 'Desculpas' },
  {
    value: SHOP_COUPON_CATEGORY_BFLU_SHIPMENT,
    label: 'Envio para BFLUs',
    displayName: 'Envio para BFLUs'
  }
];

export const shopCouponCategoryMap: Record<string, string> =
  Object.fromEntries(
    SHOP_COUPON_CATEGORIES.map(({ value, label }) => [value, label])
  );
